import axios from "axios";
import { getAccessToken } from "../../utils/okta-config";
import { API_ROOT } from "../../constants/constants";

async function getProviderOrders(sapSupNo, page, pageSize) {
  const requestOptions = {
    method: "GET",
    headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        "Access-Control-Allow-Origin": API_ROOT,
    },
  };

  const response =
    await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/forwarder/getProviderOrders/
    ${sapSupNo}/${page}/${pageSize}`, requestOptions);
  const providerList = response.data.pickupPage;
  return providerList;
}
export default getProviderOrders;